export default __webpack_public_path__ + "static/media/ripplr-logo.e6a18ff8.svg";